import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps, StyleRules } from '~pricing/components/PackageCta/types';
import grow2529Theme from '../../theme/grow2529-theme';

export default createMemoStyles<StyleRules, StyleProps, PricingAppTheme>(
  ({ pricingPalette, spacing }: PricingAppTheme) => ({
    CTAMargin: {
      marginTop: spacing[3],
      [MD_MEDIA_QUERY]: {
        marginTop: 'auto',
      },
    },
    CTA: {
      extend: 'CTAMargin',
      display: 'flex',
      padding: [0, spacing[4]],
      '& a': {
        borderRadius: 2,
        flex: 1,
        backgroundColor: ({ packageName }: StyleProps) => grow2529Theme[packageName]?.primary,
        border: 'none',
        '&:hover, &:focus': {
          backgroundColor: ({ packageName }: StyleProps) => grow2529Theme[packageName]?.primary,
        },
      },
    },
    noCTA: {
      extend: 'CTAMargin',
      display: 'flex',
      justifyContent: 'center',
      background: 'none',
      border: 'none',
      '& button': {
        color: pricingPalette.colors.black,
      },
    },
  })
);
